import React, {
    forwardRef,
    useImperativeHandle,
} from "react";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { useTheme } from "@mui/material";
import { autoBatchEnhancer } from "@reduxjs/toolkit";

const SweetAlert = forwardRef((props, ref) => {

    const Swal = useSwalWrapper();
    const theme = useTheme();


    useImperativeHandle(ref, () => ({
        showSweetAlerts(variant, message, timer) {
            sweetAlerts(variant, message, timer);
        }

    }));
    const sweetAlerts = (variant, message, timer) => {
        const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: timer ? timer : 3000,
            timerProgressBar: true,
            width: 'auto'
            //   onOpen: (toast) => {
            //     toast.addEventListener("mouseenter", Swal.stopTimer);
            //     toast.addEventListener("mouseleave", Swal.resumeTimer);
            //   },
        });

        Toast.fire({
            icon: variant,
            title: message,
            background: theme.palette.background.paper,
        });
    };
    return (
        <div></div>
    )
})

export default SweetAlert